var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form-create", {
    staticClass: "_fc-validate",
    attrs: { rule: _vm.rule, option: _vm.option, value: _vm.formValue },
    on: { "update:value": _vm.onInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }